/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordBooleanFieldComponent } from '../../admin/form/form-record/fields/boolean/form-record-boolean-field.component';
/* eslint-enable */

export class FormRecordBooleanFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordBooleanFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
